import React, { useState,useRef,useEffect }  from 'react';
import { Popconfirm, message, } from 'antd';
import { EditOutlined,DeleteOutlined,PlusOutlined } from '@ant-design/icons';
import Candidate from '../components/candidate';
import {api_status_list,api_interviewer_list,api_position_list} from '../../api';

export default () => {
  const [invitationStatusEnum, setInvitationStatusEnum] = useState({});
  const [invitationStatusList, setInvitationStatusList] = useState([]);
  const [candidatesStatusEnum, setCandidatesStatusEnum] = useState({});
  const [candidatesStatusList, setCandidatesStatusList] = useState([]);
  const [interviewList, setInterviewList] = useState([]);
  const [interviewEnum, setInterviewEnum] = useState({});
  const [positionList, setPositionList] = useState([]);
  const [positionEnum, setPositionEnum] = useState({});

  useEffect(() => {
    getStatusList();
    getInterviewerList();
    getPositionList();
  }, []);
  

  // 获取状态列表
  const getStatusList = async ()=>{
    try {
      api_status_list({}).then((res) => {
        console.log('api_status_list-res-----------------', res);
        // var flag = checkLogin('A', res.data)
        if (res.data.code == 9) {
          // 订单状态
          var status = [];
          var senum = {};
          // for(let item of res.data.list.order_status){
          //   status.push(item);
          //   senum[item.value] = {text:item.label};
          // }
          // setOrderStatusEnum(senum);
          // setOrderStatusList(status);
          // 邀约状态
          status = [];
          senum = {};
          for(let item of res.data.list.invitation_status){
            status.push(item);
            senum[item.value] = {
              text:item.label,
              status:item.status, 
              color:item.color,
              edit:item.edit,
              pause:item.pause,
              cancel:item.cancel,
              stop:item.stop,
              restart:item.restart,
            };
          }
          setInvitationStatusEnum(senum);
          setInvitationStatusList(status);
          // 候选人状态
          status = [];
          senum = {};
          for(let item of res.data.list.candidates_status){
            status.push(item);
            senum[item.value] = {text:item.label, status:item.status, color:item.color};
          }
          setCandidatesStatusEnum(senum);
          setCandidatesStatusList(status);
          // 面试方式
          // status = [];
          // senum = {};
          // for(let item of res.data.list.interview_method){
          //   status.push(item);
          //   senum[item.value] = {text:item.label};
          // }
          // setInterviewMethodEnum(senum);
          // setInterviewMethodList(status);
          // // 优先选项
          // status = [];
          // senum = {};
          // for(let item of res.data.list.prior_option){
          //   status.push(item);
          //   senum[item.value] = {text:item.label};
          // }
          // setPriorOptionEnum(senum);
          // setPriorOptionList(status);
        }else
          message.error(res.data.msg);
      });
    } catch (error) {
      console.log('catch-error------------', error)
      // return false;
    }

  }
 
  // 获取面试官列表
  const getInterviewerList = async ()=>{
    try {
      api_interviewer_list({}).then((res) => {
        console.log('api_interviewer_list-res-----------------', res);
        // var flag = checkLogin('A', res.data)
        if (res.data.code == 9) {
          var status = [];
          var senum = {};
          for(let item of res.data.list){
            // status.push({value:item.interviewer_id, label:item.name});
            status.push(item);
            senum[item.interviewer_id] = {text:item.name, phone:item.phone, email:item.email};
          }
          setInterviewEnum(senum);
          setInterviewList(status);
        }else
          message.error(res.data.msg);
      });
    } catch (error) {
      console.log('catch-error------------', error)
      // return false;
    }

  }
  
  // 获取岗位列表
  const getPositionList = async ()=>{
    try {
      api_position_list({}).then((res) => {
        console.log('api_position_list-res-----------------', res);
        // var flag = checkLogin('A', res.data)
        if (res.data.code == 9) {
          var status = [];
          var senum = {};
          for(let item of res.data.list){
            status.push({value:item.name, label:item.name});
            senum[item.id] = {text:item.name};
          }
          setPositionEnum(senum);
          setPositionList(status);
        }
        else
            message.error(res.data.msg);
      });
    } catch (error) {
      console.log('catch-error------------', error)
      // return false;
    }
  }

  return (
    <div>
      <Candidate
        from="menu"
        showModal={true}
        rowInfo={{}}
        invitationStatusEnum={invitationStatusEnum}
        candidatesStatusEnum={candidatesStatusEnum}
        interviewEnum={interviewEnum}
        positionEnum={positionEnum}
      />

    </div>
  );
};